import React from "react";
import { Modal, ModalClose } from "@govlaunch/core";
import UpgradeAccountBanner from "~/components/vendor/profile/UpgradeAccountBanner";
import MakersIcon from "~/components/icons/MakersIcon";
import UpgradeToMakersProBanner from "~/components/vendor/profile/UpgradeToMakersProBanner";
import { useIntl } from "react-intl";

interface IUpgradeAccountBannerModalProps {
  isOpen: boolean;
  toggleOpen: any;
  isVendorBasic: boolean;
}
export default function UpgradeAccountBannerModal({
  isOpen,
  toggleOpen,
  isVendorBasic,
}: IUpgradeAccountBannerModalProps) {
  const intl = useIntl();

  return (
    <Modal isOpen={isOpen} onRequestClose={toggleOpen}>
      <ModalClose onClick={toggleOpen} />
      {isVendorBasic ? (
        <UpgradeAccountBanner
          icon={<MakersIcon width={80} height={80} />}
          title={intl.formatMessage({ defaultMessage: 'Upgrade to {plan}', id: '/gko4g' }, { plan: "Makers" })}
          plan="Makers"
          css={{
            border: 0,
            borderRadius: 0,
          }}
        />
      ) : (
        <UpgradeToMakersProBanner />
      )}
    </Modal>
  );
}
